import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LogBase from "./_LogBase.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const columns = [
  { prop: "action_date", label: "Огноо" },
  { prop: "username", label: "Хэрэглэгч" },
  { prop: "ip_address", label: "IP" },
  { prop: "patch_id", label: "Patch" },
  { prop: "patch_number", label: "Patch №" },
  { prop: "provider_regnum", label: "Нийлүүлэгч" },
  { prop: "provider_branch", label: "Салбар" },
  { prop: "file_path", label: "Файл" },
  { prop: "file_size", label: "Хэмжээ" },
  { prop: "action", label: "Action" }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LogBase, {
    title: "Амжилттай нийлүүлсэн лог",
    endpoint: "/logs/success",
    columns: columns,
    show: { ip: true, provider: true, branch: true, patch: true }
  }))
}
}

})